import { Component, ElementRef, HostListener, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_service/api.service';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { URLS } from 'src/app/constants/URLS';

declare let window:any;

@Component({
  selector: 'app-cc-prime-category',
  templateUrl: './cc-prime-category.component.html',
  styleUrls: ['./cc-prime-category.component.css']
})
export class CcPrimeCategoryComponent implements OnInit {

  category:string = '';
  category_id:number;
  videos:any;
  videoCount:any;
  contents:any;
  firstIndex:number = 0;
  lastIndex:number = 20;
  isLoading = false;
  serverDown:boolean = false;
  skeletonCount:any;
  hasReachedEnd: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private el: ElementRef,
    private authService: AuthenticateserviceService,
    private mycontentService: MycontentserviceService,
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    window.addEventListener('resize', this.calculateSkeletons.bind(this)); 
    this.route.queryParamMap.subscribe((result:any) => {
      this.category_id = result.params['id']; 
      if (this.category_id) {
        this.getCc_primeCategoryWise(this.category_id);
      }
    });
    this.route.queryParams.subscribe((params)=>{
      this.videoCount = params['no'];
      console.log(this.videoCount)
    })
    this.calculateSkeletons();
  }

  calculateSkeletons() {
    const screenWidth = window.innerWidth;
  
    if (screenWidth >= 1920) {
      console.log(this.skeletonCount)
      this.skeletonCount = 15;
    } else if (screenWidth >= 1440) {
      console.log(this.skeletonCount)
      this.skeletonCount = 12;
    } else if (screenWidth >= 1024) {
      console.log(this.skeletonCount)
      this.skeletonCount = 8;
    } else if (screenWidth >= 768) {
      console.log(this.skeletonCount)
      this.skeletonCount = 6;
    } else {
      console.log(this.skeletonCount)
      this.skeletonCount = 3;
    }
  }
  
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.calculateSkeletons.bind(this));
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    
    this.scrollTimeout = setTimeout(() => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const totalHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight || 0;
      const threshold = 200;
      
      const totalCount = parseInt(this.videoCount);
      
      console.log('Scroll check:', {
        scrollPosition,
        windowHeight,
        totalHeight,
        nearBottom: scrollPosition + windowHeight >= totalHeight - threshold,
        isLoading: this.isLoading,
        hasReachedEnd: this.hasReachedEnd,
        videosLength: this.videos?.length,
        videoCount: this.videoCount,
        totalCount
      });
      
      if (scrollPosition + windowHeight >= totalHeight - threshold && 
          !this.isLoading && 
          !this.hasReachedEnd &&
          this.videos?.length < totalCount) {
        this.getMoreCc_primeCategoryWise(this.category_id!, this.firstIndex + 20, this.lastIndex + 20);
      }
    }, 100); 
  }
  
  private scrollTimeout: any;

  getMoreCc_primeCategoryWise(category_id: number, firstIndex: number, lastIndex: number): void {
    if (this.isLoading || this.hasReachedEnd) {
      console.log('Blocked: isLoading=', this.isLoading, 'hasReachedEnd=', this.hasReachedEnd);
      return;
    }
    if (this.contents && this.contents.length >= this.videoCount) {
      console.log("Setting hasReachedEnd=true, contents.length=", this.contents.length, "videoCount=", this.videoCount);
      this.hasReachedEnd = true;
      return;
    }
    console.log('Loading more videos...', { firstIndex, lastIndex, currentLength: this.contents?.length, totalCount: this.videoCount });
    this.isLoading = true;
    this.firstIndex = firstIndex;
    this.lastIndex = lastIndex;
    const url = `${URLS.getCcPrimeVideoCategory}?start_index=${firstIndex}&last_index=${lastIndex}&video_type=premium&category_id=${category_id}`;
    this.apiService.post(url, {}).subscribe(
      (result: any) => {
        const data = result?.data || []; 
        console.log('Received data:', data.length, 'items');
        if (data.length === 0) {
          this.hasReachedEnd = true;
          this.isLoading = false;
          console.log('No more data - reached end');
          return;
        }
        this.contents = [...this.contents, ...data];
        this.videos = [...this.videos, ...this.mapVideos(data)];
        this.mapwatchContent();
        this.mapDownloadContent();
        this.isLoading = false;
        if (this.contents.length >= parseInt(this.videoCount)) {
          console.log("Reached end after loading - contents.length=", this.contents.length, "videoCount=", this.videoCount);
          this.hasReachedEnd = true;
        }
      },
      (error) => {
        console.error('Error loading more videos:', error);
        this.isLoading = false;
      }
    );
  }
  
  getCc_primeCategoryWise(category_id: number): void {
    this.isLoading = true;
    this.hasReachedEnd = false; 
    const url = `${URLS.getCcPrimeVideoCategory}?start_index=${this.firstIndex}&last_index=${this.lastIndex}&video_type=premium&category_id=${category_id}`;
    this.apiService.post(url, {}).subscribe(
      (result: any) => {
        const data = result?.data || []; 
        console.log('Initial load:', data);
        if (!this.videoCount) {
          this.videoCount = result?.videoCount || data.videoCount || data.length;
        }
        console.log('VideoCount:', this.videoCount, 'Loaded:', data.length);
        this.contents = data;
        this.videos = this.mapVideos(data);
        if (data.length > 0) {
          this.category = data[0].category;
        }
        const totalCount = parseInt(this.videoCount);
        if (this.contents.length >= totalCount) {
          this.hasReachedEnd = true;
          console.log('All content loaded in initial call');
        }
        this.mapwatchContent();
        this.mapDownloadContent();
        this.isLoading = false;
      },
      (error) => {
        console.error(error);
        this.isLoading = false;
        if(error?.statusText === 'Unknown Error'){
          this.serverDown = !this.serverDown;
        }
      }
    );
  }

  private mapVideos(data: any[]): any[] {
    return data.map((item: any) => {
      const modifiedDate = this.authService.calculateModifiedDate(item.uploadedTime);
      const duration = item.videoDuration.startsWith('00:') ? item.videoDuration.slice(3) : item.videoDuration;
      const channelDesc = item?.properties?.find((property: any) => property.name === 'channel_desc')?.value || '';
      const scale = item?.properties?.find((property: any) => property.name === 'scale')?.value || '';
      return {
        ...item,
        modifiedDate,
        isPlaying: false,
        videoCategory: 'ccPrime',
        videoDuration: duration,
        channel_desc: channelDesc,
        aspectRatio: scale
      };
    });
  }

  mapwatchContent() {
    var usrId = localStorage.getItem("userId");
    this.mycontentService.getWatchListOfUser(usrId).subscribe(watchresult => { 
      this.videos.forEach(section => {
        section.isInWatchList = false;
          watchresult.forEach(wlitem => {
            if (section.vidLibId == wlitem.vidLibId) {
              section.isInWatchList = true;
            }
        })
      })
    });
    this.isLoading=false
  }

  async listContent() {
    return await window.storage?.list();
  }
  
  async mapDownloadContent() {
    try {
      const downloadResult = await this.listContent();
      const downloadedVideoMap = new Map();
      downloadResult.forEach(dlitem => {
        downloadedVideoMap.set(dlitem.vidLibId, true);
      });
      this.videos.forEach(section => {
        section.isDownloaded = downloadedVideoMap.has(section.vidLibId);
      });
    } catch (error) {
      console.error('Error mapping download content:', error);
    }
  }

  openVideoPlayer(vidLibId: number): void {
    this.router.navigate(['tqr','video', vidLibId]);
  }

  currentVidName: string;
  playVideo(video: any) {
    // this.filteredVideos.forEach((v) => {
    //   v.isPlaying = false;
    // });
    this.currentVidName = video.vidName;
    video.isPlaying = true;
  }
  
  stopVideo(video: any) {
    video.isPlaying = false;
  }

  stopEvent(event:Event){
    event.stopPropagation();
  }

  @Input() textToCopy: string;
  displayModal: boolean = false;

  copyToClipboard() {
    navigator.clipboard.writeText(this.textToCopy);
    this.closeModal();
  }

  openModal() {
    this.displayModal = true;
  }

  closeModal() {
    this.displayModal = false;
  }
}